import { render } from "./ViewAssessors.vue?vue&type=template&id=74690b25&scoped=true"
import script from "./ViewAssessors.vue?vue&type=script&lang=js"
export * from "./ViewAssessors.vue?vue&type=script&lang=js"

import "./ViewAssessors.vue?vue&type=style&index=0&id=74690b25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74690b25"]])

export default __exports__